import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-zig-zag', 'ArrowZigZag', [["path",{"d":"M6 20v-10l10 6v-12"}],["path",{"d":"M13 7l3 -3l3 3"}]]);